import { motion } from "framer-motion";
import { ExternalLink, Users, Calculator, Wand2 } from "lucide-react";

const platforms = [
  {
    icon: Wand2,
    name: "رواج الذكية",
    domain: "rawajsmart.com",
    tagline: "التسويق بالذكاء الاصطناعي",
    desc: "منصة تسويق ذكية تولّد استراتيجيات ومحتوى احترافي (نصوصاً وصوراً وفيديو) بتعليق صوتي سعودي — للمنشآت الصغيرة والمتوسطة.",
    features: ["استراتيجيات تسويق كاملة", "مولّد فيديو باللهجة السعودية", "اشتراكات ومدفوعات PayTabs"],
    color: "from-[#D4AF37]/20 to-[#D4AF37]/5",
    border: "border-[#D4AF37]/30",
  },
  {
    icon: Users,
    name: "برولانسر",
    domain: "prolancer.sa",
    tagline: "منصة العمل الحر السعودية",
    desc: "تربط أصحاب المشاريع بالمستقلين المحترفين في المملكة — مستقلون موثّقون، عقود واضحة، ومدفوعات آمنة بالمراحل.",
    features: ["مستقلون موثّقون", "مدفوعات آمنة بالمراحل", "عقود ونزاعات عادلة"],
    color: "from-[#38BDF8]/20 to-[#38BDF8]/5",
    border: "border-[#38BDF8]/30",
  },
  {
    icon: Calculator,
    name: "حاسبتنا الذكية",
    domain: "prolancer.app",
    tagline: "تسعير خدمات العمل الحر",
    desc: "حاسبة ذكية تساعد المستقلين على تسعير خدماتهم بالريال السعودي وفق معايير السوق — من التصميم والتطوير إلى التسويق.",
    features: ["تسعير وفق السوق السعودي", "تغطي كل مجالات العمل الحر", "مجانية وسريعة"],
    color: "from-[#10B981]/20 to-[#10B981]/5",
    border: "border-[#10B981]/30",
  },
];

export const Platforms = () => (
  <section id="platforms" data-testid="platforms-section" className="relative py-24 sm:py-32 overflow-hidden">
    <div className="absolute top-1/4 -left-40 w-[420px] h-[420px] rounded-full blur-[150px] opacity-15 bg-[#D4AF37]" aria-hidden="true" />
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-14"
      >
        <div className="font-mono-tech text-xs sm:text-sm tracking-[0.25em] text-[#D4AF37] mb-4" dir="ltr">— OUR PLATFORMS</div>
        <h2 className="font-display font-extrabold text-2xl sm:text-3xl lg:text-4xl text-[#F8FAFC]" data-testid="platforms-title">
          منصاتنا <span className="gold-text">معرض أعمالنا الحيّة</span>
        </h2>
        <p className="mt-4 max-w-2xl font-body text-base sm:text-lg text-[#94A3B8]">
          ثلاث منصات رقمية حيّة نمتلكها ونديرها — تعمل الآن بمستخدمين ومدفوعات حقيقية.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {platforms.map((p, i) => (
          <motion.div
            key={p.domain}
            initial={{ opacity: 0, y: 36 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.65, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className={`glass-card rounded-3xl p-7 group flex flex-col bg-gradient-to-b ${p.color} border ${p.border}`}
            data-testid={`platform-card-${p.domain.replace(/\./g, "-")}`}
          >
            <div className="flex items-start justify-between gap-4">
              <div className="w-12 h-12 rounded-2xl bg-white/10 border border-white/20 flex items-center justify-center shrink-0 group-hover:bg-white/15 transition-colors duration-300">
                <p.icon size={22} className="text-white" />
              </div>
              <span className="num-badge rounded-full px-3 py-1 text-[10px] text-[#E5C158]/90 shrink-0">{p.tagline}</span>
            </div>
            <h3 className="mt-6 font-display font-bold text-xl sm:text-2xl text-[#F8FAFC]">{p.name}</h3>
            <p className="mt-3 font-body text-sm sm:text-base leading-relaxed text-[#94A3B8] flex-1">{p.desc}</p>
            <ul className="mt-5 space-y-2">
              {p.features.map((f) => (
                <li key={f} className="flex items-center gap-2 font-body text-sm text-[#CBD5E1]">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37] shrink-0" />
                  {f}
                </li>
              ))}
            </ul>
            <a
              href={`https://www.${p.domain}`}
              target="_blank"
              rel="noreferrer"
              data-testid={`platform-link-${p.domain.replace(/\./g, "-")}`}
              className="mt-6 inline-flex items-center justify-center gap-2 rounded-full bg-white/10 border border-white/20 px-6 py-3 font-display font-bold text-white hover:bg-white/20 transition-all duration-300"
            >
              زيارة المنصة
              <ExternalLink size={16} />
            </a>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
